import React from 'react';
import { Typography, TypographyProps } from '@drone-js/core';
import styled from 'styled-components';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';

const StyledTypography = styled(Typography)`
    overflow-wrap: anywhere;
`;

const processTextWithWordBreaks = (text: string): string => {
    if (!text) return text;
    return text.replace(/([/\-:;.,!?()[\]{}"'`~@#$%^&*+=|\\<>])/g, '$1<wbr>');
};

type TypographyWithWordBreakProps = TypographyProps & React.PropsWithChildren<{ children: string }>;

const TypographyWithWordBreak = (props: TypographyWithWordBreakProps) => {
    return (
        <StyledTypography {...props}>
            <AgodaMarkdown input={processTextWithWordBreaks(props.children)} inline={true} skipHtml={false} />
        </StyledTypography>
    );
};

TypographyWithWordBreak.displayName = 'TypographyWithWordBreak';

export default TypographyWithWordBreak;
